<template>
	<section>
		<el-row class="container">
			<el-col :span="24">
				<el-col :span="8">
					<div style="width: 200px;">
						<h3 class="title">今日</h3>
						{{today}}
						<div style="border: 0.5px solid #e4e3e3; margin-top:10px; padding: 10px;border-top: 0;">
							<h4 class="title">账户信息</h4>
							<h4 style="border-top:0.5px solid #e4e3e3; ">账户余额</h4>
							<h4 style="font-size:24px;">{{user.balance}} <span style="font-size: 14px">云豆</span>	</h4>
							<el-button type="primary" style="width:90%;" disabled="disabled">账户充值</el-button>
						</div>
					</div>
				</el-col>
				<el-col :span="10" class="header">
					<el-form style="text-align: right;width: 650px;">
						<el-form-item>
							<h3 style="text-align: left">基本信息</h3>
						</el-form-item>
						<el-form-item>
							<el-col :span="8">
								<label>* 账号：</label>
							</el-col>
							<el-col :span="8">
								<el-input style="width: 250px;"
										  size="small"
										  placeholder="请输入内容"
										  v-model="user.account"
										  :disabled="true">
								</el-input>
							</el-col>
							<el-col :span="8">
								<el-button type="primary" style="width:66%;" @click="handlePasswd">登录密码修改</el-button>
							</el-col>
						</el-form-item>
						<el-form-item>
							<el-col :span="8">
								<label> * 账号昵称：</label>
							</el-col>
							<el-col :span="8">
								<el-input style="width: 250px;"
										  size="small"
										  placeholder="请输入内容"
										  v-model="user.nickname"
										  :disabled="nickname">
								</el-input>
							</el-col>
							<el-col :span="8">
								<el-button type="primary" style="width:80px;" @click.native.prevent="editNickName">编辑</el-button>
								<el-button type="primary" style="width:80px;" @click.native.prevent="saveNickName">保存</el-button>
							</el-col>
						</el-form-item>
						<el-form-item>
							<el-col :span="8">
								<label>* 账号绑定的手机号：</label>
							</el-col>
							<el-col :span="8">
								<el-input style="width: 250px;"
										  size="small"
										  placeholder="请输入内容"
										  v-model="user.phone"
										  :disabled="true">
								</el-input>
							</el-col>
							<el-col :span="8">
								<el-button type="primary" style="width:80px;" @click.native.prevent="editPhoneNumber">修改</el-button>
							</el-col>
						</el-form-item>
						<el-form-item>
							<el-col :span="8">
								<label>累计购买总数：{{user.grand_total_purchase}}云豆</label>
							</el-col>

							<el-col :span="8">
								<label>累计划拨总数：{{user.grand_total_transfer}}云豆</label>
							</el-col>
						</el-form-item>
					</el-form>

				</el-col>

			</el-col>

			<el-col :span="24">
				<div id="chartLine" style="margin-top:20px; width: calc(100% - 250px); height:400px;"></div>
			</el-col>
		</el-row>
		<!--编辑界面-->
		<el-dialog title="验证手机" width="600px" :visible.sync="phoneFormVisible">
			<el-form :model="phoneForm" ref="phoneForm" :rules="rules" label-width="90px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="手机号:" prop="phone">
							<el-input style="width: 250px;"
									  size="small"
									  type="number"
									  clearable
									  placeholder="请输入手机号"
									  v-model="phoneForm.phone">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="验证码:" prop="code">
							<el-input style="width: 250px;"
									  size="small"
									  placeholder="请输入验证码"
									  type="number"
									  clearable
									  v-model="phoneForm.code">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item>
							<el-button type="primary" style="width:100px;" @click.native.prevent="getVerificationCode">获取验证码</el-button>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item>
							<el-button type="primary" style="width:100px;" @click.native.prevent="savePhoneNumber">提交</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>
	</section>
</template>

<script>
	import echarts from 'echarts'
	import store from "../vuex/store";
	import $ from "jquery";

	Date.prototype.Format = function(fmt) {
		//author:wangweizhen
		var o = {
			"M+" : this.getMonth()+1,                 //月份
			"d+" : this.getDate(),                    //日
			"h+" : this.getHours(),                   //小时
			"m+" : this.getMinutes(),                 //分
			"s+" : this.getSeconds(),                 //秒
			"q+" : Math.floor((this.getMonth()+3)/3), //季度
			"S"  : this.getMilliseconds()             //毫秒
		};
		if(/(y+)/.test(fmt))
			fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
		for(var k in o)
			if(new RegExp("("+ k +")").test(fmt))
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
		return fmt;
	};
	export default {
		data() {
			return {
				today: new Date().Format("yyyy-MM-dd")+" 星期" + "日一二三四五六".charAt(new Date().getDay()),
				chartLine: null,
				input:"",
				user: {},
				nickname: true,
				days: 30,
				phoneFormVisible:false,
				phoneForm:{
					phone: "",
					code: ""
				},
				rules: {
					phone: [
						{ required: true, message: '请输入账号绑定手机号', trigger: 'blur' },
						//{ validator: validaePass }
					],
					code: [
						{ required: true, message: '请输入验证码', trigger: 'blur' },
						//{ validator: validaePass2 }
					]
				},
			}
		},
		methods:{
			drawLineChart(data) {
				let arr = data[0].values;
				let xAxis=[],yAxis=[];
				arr.forEach(item=>{
					xAxis.push(new Date(item.x).Format("yyyy-MM-dd"));
					yAxis.push(item.y)
				});
				this.chartLine = echarts.init(document.getElementById('chartLine'));
				this.chartLine.setOption({
                    color:['#4ED8DA'],
					title: {
						text: '最近30天商家使用趋势'
					},
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: xAxis
					},
					yAxis: {
						type: 'value'
					},
					series: [
						{
							name: '云豆使用量',
							symbol:'none', //去掉折线图中的节点
							type: 'line',
							smooth: true,  //true 为平滑曲线，false为直线
							data: yAxis
						}

					]
				});
			},
			getUsedTrend(){
				let _this = this;
				let para = {
					days: _this.days
				};
				//days
				_this.$Api.getUsedTrend(para).then(res => {
          _this.drawLineChart(res);
				})
				.catch(err => {
					_this.$message({
						message: err,
						type: "error"
					});
				});
			},
			getUserInfo(){
				let _this = this;
				_this.$Api.getUserInfo().then(res => {
          _this.user = res;
				})
				.catch(err => {
					_this.logining = false;
					_this.$message({
						message: err,
						type: "error"
					});
				});
			},
			handlePasswd(){
				document.location.href = '#/passwd';
			},
			editNickName(){
				this.nickname = false;
			},
			editPhoneNumber(){
				this.phoneFormVisible = true;
			},
			getVerificationCode(){
				let _this= this;
				if( _this.phoneForm.phone==""){
					_this.$message({
						message: "请输入手机号",
						type: "error"
					});
					return;
				}
				let params = { phone: _this.phoneForm.phone };
				let url = store.state.api+'/sms/sendcode';
				$.ajax({
					url: url,
					type: "post",
					data: params,
					cache: false,
					async: false,
					success(response) {
            _this.$message({
              message: "发送成功，请注意查收",
              type: "success"
            });
					},
					error: function (XMLHttpRequest, textStatus, errorThrown) {
						_this.logining = false;
						_this.$message({
							message: XMLHttpRequest,
							type: "error"
						});
					}
				})
			},
			savePhoneNumber(){
				let _this= this;
				_this.$refs.phoneForm.validate((valid) => {
					if (valid) {
						let params = {
							phone: _this.phoneForm.phone,
							code: _this.phoneForm.code,
						};
						_this.$Api.bindPhoneNumber(params).then(res => {
              _this.$message({
                message: message,
                type: "success"
              });
						})
						.catch(err => {
							_this.logining = false;
							_this.$message({
								message: err,
								type: "error"
							});
						});
					}

				})

			},
			saveNickName(){
				let _this = this;
				if(_this.nickname){
					return;
				}
				let params = { id_alias: _this.user.id_alias};
				_this.$Api.editUserNickName(params).then(res => {
          _this.$message({
            message: message,
            type: "success"
          });
				})
				.catch(err => {
					_this.logining = false;
					_this.$message({
						message: err,
						type: "error"
					});
				});
				_this.nickname = true;
			}
		},
		mounted() {
			this.getUserInfo();
			this.getUsedTrend()
		},
	}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Main.vue?e1eb05a8